import { render, staticRenderFns } from "./c_forget.vue?vue&type=template&id=46345220&scoped=true&"
import script from "./c_forget.vue?vue&type=script&lang=js&"
export * from "./c_forget.vue?vue&type=script&lang=js&"
import style0 from "./c_forget.vue?vue&type=style&index=0&id=46345220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46345220",
  null
  
)

export default component.exports